import { render, staticRenderFns } from "./check-sms.vue?vue&type=template&id=03cbfc49&"
import script from "./check-sms.vue?vue&type=script&lang=js&"
export * from "./check-sms.vue?vue&type=script&lang=js&"
import style0 from "./check-sms.vue?vue&type=style&index=0&id=03cbfc49&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports